import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useMemo } from "react";
import { useTopicPage_UpdatePostMutation } from "sprout-graphql";
import { formatToTipTapJSON } from "sprout-lib/dist/parser";
import { BottomSheet } from "sprout-ui-dom/dist/BottomSheet";
import { useSnackbar } from "sprout-ui-dom/dist/Snackbar";
import TopicPageEditorPostDesktop from "../../TopicPageEditorPost/TopicPageEditorPostDesktop";
import TopicPageEditorPostMobile from "../../TopicPageEditorPost/TopicPageEditorPostMobile";
import { useTopicPageViewsTopicEditor } from "../TopicPageViewsTopicEditorContext";
const TopicPageViewsTopicListPostEditor = (props)=>{
    const { post , topicId  } = props;
    const { id , description  } = post;
    const { state , dispatch  } = useTopicPageViewsTopicEditor();
    const initialState = useMemo(()=>{
        return description ? formatToTipTapJSON(description, "BASIC").json : undefined;
    }, [
        description
    ]);
    const openEditEditor = state.editor === "EDIT_POST_DESCRIPTION" && state.editorPosition === id;
    const closeEditor = useCallback(()=>{
        dispatch({
            type: "CLOSE_EDITOR"
        });
    }, [
        dispatch
    ]);
    const handleEscape = useCallback(()=>{
        closeEditor();
        return true;
    }, [
        closeEditor
    ]);
    const [updatePost] = useTopicPage_UpdatePostMutation();
    const showSnackbar = useSnackbar();
    const handleUpdate = useCallback(({ text , link  })=>{
        if (!text.trim() && !link) return;
        const isLink = link !== null && link.startsWith("http");
        updatePost({
            variables: {
                itemId: id,
                // items_check6
                description: text || (link ? isLink ? null : link : ""),
                // items_check7
                // We want to retain w/e the exiting link is, instead of removing it
                url: isLink ? link : undefined
            }
        }).catch(()=>{
            showSnackbar.error();
        });
        closeEditor();
    }, [
        closeEditor,
        id,
        showSnackbar,
        updatePost
    ]);
    const handleEnter = useCallback(({ getStateAsText  })=>{
        const { link , text  } = getStateAsText();
        handleUpdate({
            link,
            text
        });
        return true;
    }, [
        handleUpdate
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(BottomSheet, {
                open: openEditEditor && state.variant === "mobile",
                unmountOnExit: true,
                children: /*#__PURE__*/ _jsx(TopicPageEditorPostMobile, {
                    initialState: initialState,
                    topicId: topicId,
                    closeEditor: closeEditor,
                    onEscape: handleEscape,
                    onEnter: handleEnter,
                    onSave: handleEnter
                })
            }),
            openEditEditor && state.variant === "desktop" && /*#__PURE__*/ _jsx(TopicPageEditorPostDesktop, {
                initialState: initialState,
                topicId: topicId,
                closeEditor: closeEditor,
                onEscape: handleEscape,
                onEnter: handleEnter,
                onSave: handleEnter
            })
        ]
    });
};
export default TopicPageViewsTopicListPostEditor;
